<template>
  <div class="CompleteIOInDate">
    <section-date-search-panel :accessTo="'53'" @search="search" />
    <box class="mt-2" :title="$t('personelList')">
      <div class="vacationList">
        <div v-if="list.length > 0">
          <CompleteIOInDateListWeb
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClick"
          />
          <CompleteIOInDateListMob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import CompleteIOInDateListMob from "../../components/personelOperationReport/completeIoInDateList/CompleteIOInDateListMob.vue";
import CompleteIOInDateListWeb from "../../components/personelOperationReport/completeIoInDateList/CompleteIOInDateListWeb.vue";
import SectionDateSearchPanel from "../../components/personelOperationReport/SectionDateSearchPanel.vue";
import ResultType from "../../model/ResultType";
export default {
  components: {
    SectionDateSearchPanel,
    CompleteIOInDateListWeb,
    CompleteIOInDateListMob,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    search(searchParams) {
      var params = {
        date: searchParams.iDate,
        sectionCode: searchParams.sectionCode,
      };

      this.$store.dispatch("GetCompleteIo", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.list = result.data.Table;
        }
      });
    },
    onClick() {},
  },
};
</script>

<style>
</style>